import { FC } from 'react';

import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { Icon } from '@ravago/shared/radiance/components/icon/components/Icon/Icon';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

import { Link } from '../../../../shared/link/link';

interface Props {
   language: string;
   ulProspectorId: string | undefined;
   centered?: boolean;
}

export const RelatedDocumentUlProspectorLink: FC<Props> = ({ ulProspectorId, centered = false }) => {
   const translate = useTranslations();

   return (
      <Box direction="row" gap="xs" width="100%" justify={centered ? 'center' : 'end'} items="center">
         <Link href={`https://materials.ulprospector.com/en/document?e=${ulProspectorId}`} target="_blank" underline="none">
            <Icon size="small" icon="external-link" />
         </Link>
         <Link href={`https://materials.ulprospector.com/en/document?e=${ulProspectorId}`} target="_blank">
            <Typography component="p" variant="small" color="inherit">
               {translate('related-documents.ul-prospector')}
            </Typography>
         </Link>
      </Box>
   );
};
